import { render, staticRenderFns } from "./EditType.vue?vue&type=template&id=291a1e2e"
import script from "./EditType.vue?vue&type=script&lang=js"
export * from "./EditType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports